// Restricts which product categories are shown on the frontend.
// Configure REACT_APP_VISIBLE_CATEGORIES in the frontend .env as a comma-separated
// list of category names to show (case-insensitive). Leave empty/unset to show all.
//
//   REACT_APP_VISIBLE_CATEGORIES=Fruits,Dairy,Vegetables

const allowed = (process.env.REACT_APP_VISIBLE_CATEGORIES || '')
  .split(',')
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

// True only when a restriction is configured.
export const hasCategoryRestriction = allowed.length > 0;

// Whether a single category name is allowed to be shown.
export const isCategoryVisible = (name) => {
  if (!hasCategoryRestriction) return true;
  return allowed.includes(String(name || '').trim().toLowerCase());
};

// Filter an array of category objects ({ name, ... }) down to the configured set.
export const filterVisibleCategories = (categories) => {
  if (!Array.isArray(categories)) return [];
  if (!hasCategoryRestriction) return categories;
  return categories.filter((c) => isCategoryVisible(c?.name));
};
